import { render, staticRenderFns } from "./Carrera.vue?vue&type=template&id=efc1f7be&"
import script from "./Carrera.vue?vue&type=script&lang=js&"
export * from "./Carrera.vue?vue&type=script&lang=js&"
import style0 from "./Carrera.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports